import styled from 'styled-components';
export const Wrapper = styled.div `
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
  padding: 35px 65px;
`;
export const LogoImage = styled.img `
  height: 38px;
  width: 117px;
  object-fit: contain;
`;
export const Title = styled.h3 `
  font-family: Poppins;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #4b3a5a;
`;
export const Description = styled.p `
  font-family: Poppins;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #4b3a5a;
`;
export const LoaderContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;
